$(function(){

    // open menu dropdown on hover
    $(".dropdown, .btn-group").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });

    // add captions to images
    $('.content .img-right').each(function(index) {
        var img = $(this).removeClass('img-right').wrap('<div class="img-wrap imgs-right" />');
        if (img.attr("alt")) $('<div class="img-caption">' + img.attr("alt") + '</div>').insertAfter(img);
    });
    $('.content .img-left').each(function(index) {
        var img = $(this).removeClass('img-left').wrap('<div class="img-wrap imgs-left" />');
        if (img.attr("alt")) $('<div class="img-caption">' + img.attr("alt") + '</div>').insertAfter(img);
    });
    $('.content .img-center').each(function(index) {
        var img = $(this).removeClass('img-center').wrap('<div class="img-wrap imgs-center" />');
        if (img.attr("alt")) $('<div class="img-caption">' + img.attr("alt") + '</div>').insertAfter(img);
    });

    // Tarte Au Citron
    tarteaucitron.init({
        "privacyUrl": "/politique-de-confidentialite",
        "hashtag": "#tarteaucitron",
        "cookieName": "tarteaucitron",
        "orientation": "bottom",
        "groupServices": false,
        "showAlertSmall": true,
        "cookieslist": false,
        "closePopup": false,
        "showIcon": false,
        //"iconSrc": "",
        "iconPosition": "BottomRight",
        "adblocker": false,
        "DenyAllCta" : true,
        "AcceptAllCta" : true,
        "highPrivacy": true,
        "handleBrowserDNTRequest": false,
        "removeCredit": true,
        "moreInfoLink": false,
        "useExternalCss": true,
        "useExternalJs": true,
        "mandatory": true
    });


    tarteaucitron.services.bioscene = {
        "key": "bioscene",
        "type": "other",
        "name": "Bio-Scène",
        "uri": "https://www.bio-scene.org/",
        "needConsent": true,
        "cookies": ["_ga", "_gid"],
        "js": function () {
            "use strict";
            tarteaucitron.fallback(['bs_embed'], function (elem) {
                console.log(elem);
                var src = elem.getAttribute("data-src");
                return '<iframe src="' + src + '"></iframe>';
            });
        },
        "fallback": function () {
            "use strict";
            var id = 'bioscene';
            tarteaucitron.fallback(['bs_embed'], function (elem) {
                return tarteaucitron.engage(id);
            });
        }
    };

    (tarteaucitron.job = tarteaucitron.job || []).push('bioscene');

});
